import api from "../config/axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import router from "../router";
import store from "../store";
import config from "../config/app.json";
import Vue from "vue";
const URL_AUTH = "auth/";
const URL_CLIENTE = "client/";
export const cookiePath = "userLogged" + config.name;
export const cookieExpired = "userLoggedExpired" + config.name;

export default {
  login(rut, password) {
    let data = {
      usuario: rut,
      clave: password
    };
    return api.post(URL_AUTH + "login", data);
  },
  setUserLogged(userLogged, start = null) {
    start = start || new Date().getTime();
    let expireTime = new Date(start + userLogged.tokenExp * 1000);
    delete userLogged.imagen_b64;
    let usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    Cookies.set(cookiePath, usuarioEncriptado, {
      expires: expireTime
    });
    Cookies.set(cookieExpired, expireTime);

    store.commit("setTimeout");
  },
  updateUserLogged(userLogged) {
    const usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    let current = new Date().getTime();
    let expires = Cookies.get(cookieExpired);
    let remaining = new Date(expires).getTime() - current;
    Cookies.set(cookiePath, usuarioEncriptado, {
      expires: remaining
    });
    store.dispatch("updateBits");
  },
  setUserImage(imagen) {
    sessionStorage.setItem("userImageIsla", imagen);
  },

  getUserLogged() {
    let usuarioEncriptado = Cookies.get(cookiePath);
    const bytes = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    );
    const usuario = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(usuario);
  },
  getUserImage() {
    return sessionStorage.getItem("userImageIsla");
  },
  async cerrarSesion(push = true) {
    Cookies.remove(cookieExpired);
    Cookies.remove(cookiePath);
    store.dispatch("limpiarPublicidades");
    store.commit("closeTimeout");
    await Vue.nextTick();
    if (push) await router.push({ name: "login" });
  },
  isAuthenticated() {
    return Cookies.get(cookiePath) !== undefined;
  },
  isExpireSet() {
    return Cookies.get(cookieExpired) !== undefined;
  },
  userInfo() {
    return api.get(URL_CLIENTE + "infoCliente");
  },
  info_campanias() {
    return api.get(URL_CLIENTE + "infoCampanias");
  },
  generarClave(rut, correo, telefono, serie) {
    let data = {
      usuario: rut,
      mail: correo,
      telefono: telefono,
      serie: serie
    };
    return api.post(URL_AUTH + "recuperarClave", data);
  },
  cambiarClave(cl_actual, cl_nueva) {
    let data = {
      clave_old: cl_actual,
      clave: cl_nueva,
      accion: 2
    };
    return api.put(URL_AUTH + "cambiarClave", data);
  },
  cambiarClaveCodigo(rut, cl_actual, cl_nueva) {
    let data = {
      usuario: rut,
      clave_old: cl_actual,
      clave: cl_nueva,
      accion: 1
    };
    return api.put(URL_AUTH + "cambiarClaveCodigo", data);
  }
};
